import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

import store from "@/store";

const name = "targetUser";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if ((store.state as any)[name]) {
  store.unregisterModule(name);
}

/**
 * The "Sicht auf" (view-as) choice, held as the chosen user's id.
 *
 * Read it through `getViewAsUser()` (`src/utils/ViewAs.ts`), which resolves the id against the live
 * user list and the viewer's rights. Kept across a refresh in session storage
 * (`src/utils/ViewAsSession.ts`), so this module starts empty and is filled by `restoreViewAs()`.
 */
@Module({ dynamic: true, namespaced: true, store, name })
export class TargetUserVuexModule extends VuexModule {
  /** The chosen user's id, or `null` for the viewer's own view. */
  userId: string | null = null;

  @Mutation
  setUserId(userId: string | null) {
    this.userId = userId;
  }

  @Mutation
  clear() {
    this.userId = null;
  }
}

export const TargetUserModule = getModule(TargetUserVuexModule);

/**
 * Whether a "Sicht auf" choice is stored, resolved yet or not (reactive). Read-only applies from
 * this moment: right after a page load the chosen user is not resolved until the user list arrives,
 * and nothing may be changed in that window either (ticket 2610051). Kept here, in a module that
 * imports nothing but the store, so the permission layer can read it without an import cycle.
 */
export function isViewAsSelected(): boolean {
  return TargetUserModule.userId !== null;
}

/**
 * Clears the in-memory choice. Runs on every auth event (`clearCacheAndModules`), including the one
 * on a page load: the choice that should survive a refresh is restored from session storage after it.
 */
export function clearTargetUserSelectionForNewSession() {
  TargetUserModule.clear();
}
